var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentsNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 86,
    height: 81,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.171 44.213c1.71 38.88-77.91 95.837-113.573 68.72-35.663-27.118-33.742-69.85-14.687-82.131 19.055-12.282 42.143 12.035 65.045-2.633 22.902-14.667 61.506-22.837 63.215 16.044Z",
    fill: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 47,
    y: 7,
    width: 86,
    height: 81,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAE33",
    mask: "url(#b)",
    d: "M0 0h86v21H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.68 75V41.112H66.488v6.336h5.088V75h7.104Zm19.288 0c4.576 0 7.872-1.536 9.888-4.608 2.016-3.072 3.024-7.28 3.024-12.624 0-5.312-1.008-9.504-3.024-12.576-2.016-3.072-5.312-4.608-9.888-4.608-8.64 0-12.96 5.728-12.96 17.184 0 11.488 4.32 17.232 12.96 17.232Zm0-6.384c-2.496 0-4.168-.936-5.016-2.808-.848-1.872-1.272-4.552-1.272-8.04 0-3.456.424-6.12 1.272-7.992.848-1.872 2.52-2.808 5.016-2.808 2.464 0 4.12.936 4.968 2.808.848 1.872 1.272 4.536 1.272 7.992 0 3.488-.424 6.168-1.272 8.04-.848 1.872-2.504 2.808-4.968 2.808Z",
    fill: "#383F57",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 5,
    cy: 15,
    r: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#62677A",
    x: 1.5,
    width: 7,
    height: 18,
    rx: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 5,
    cy: 15,
    r: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#62677A",
    x: 1.5,
    width: 7,
    height: 18,
    rx: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.046 81.077c0-1.829-4.175-2.982-4.691-4.612-.557-1.71 2.146-5.088 1.113-6.48-1.034-1.43-5.089.08-6.52-.954-1.431-1.033-1.232-5.367-2.942-5.923-1.63-.517-4.015 3.06-5.844 3.06-1.828 0-4.174-3.577-5.843-3.06-1.71.556-1.511 4.89-2.903 5.923-1.43 1.034-5.486-.477-6.52.954-1.033 1.431 1.63 4.77 1.114 6.48-.557 1.63-4.73 2.783-4.73 4.612 0 1.828 4.173 2.981 4.69 4.611.557 1.71-2.147 5.089-1.113 6.48 1.034 1.431 5.089-.08 6.52.954 1.43 1.034 1.232 5.367 2.942 5.884 1.63.517 4.015-3.061 5.843-3.061 1.83 0 4.175 3.578 5.844 3.06 1.71-.556 1.51-4.85 2.942-5.883 1.431-1.033 5.486.477 6.52-.954 1.033-1.431-1.63-4.77-1.113-6.48.516-1.63 4.69-2.783 4.69-4.611Z",
    fill: "#D1435B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.024 87.479-1.123-4.193 3.885 3.452 1.652-.442-1.83-6.83-1.652.443 1.134 4.231-3.896-3.49-1.652.442 1.83 6.83 1.652-.443Zm10.19-2.731-.354-1.323-2.599.696-.406-1.517 2.309-.618-.334-1.246-2.309.618-.383-1.43 2.598-.695-.352-1.314-4.25 1.139 1.83 6.829 4.25-1.139Zm4.733-1.268-.123-4.864 2.316 4.276 2.048-.548-.198-7.267-1.787.479.437 5.184-2.523-4.625-1.806.484.127 5.266-2.204-4.71-1.797.482 3.463 6.391 2.047-.548Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsNew);
export default __webpack_public_path__ + "static/media/appointments-new.54d5bd0d.svg";
export { ForwardRef as ReactComponent };